import { FormLabel, RadioGroup, FormControlLabel, FormHelperText } from '@mui/material';
import FormControl, { FormControlPropsSizeOverrides } from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import { OverridableStringUnion } from '@mui/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export interface WsRadioGroupProps {
  name: string;
  label?: string;
  selectArray: WsRadioObj[];
  size?: OverridableStringUnion<'small' | 'medium', FormControlPropsSizeOverrides>;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  row?: boolean;
  onChange?: (value: string) => void;
}
export interface WsRadioObj {
  label: string;
  value: string | number | boolean;
}
const WsRadioGroup = ({
  name,
  label,
  selectArray,
  size = 'small',
  required = false,
  disabled = false,
  row = true,
  onChange,
}: WsRadioGroupProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <FormControl fullWidth size={size} required={required} disabled={disabled}>
      <FormLabel component="legend">{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange: onFieldChange, value = '' } }) => (
          <RadioGroup
            value={value}
            onChange={(event) => {
              onChange && onChange(event.target.value);
              onFieldChange(event);
            }}
            row={row}
          >
            {selectArray.map((singleOption) => {
              return (
                <FormControlLabel
                  key={singleOption.value}
                  value={singleOption.value}
                  label={singleOption.label}
                  control={<Radio size={size} disabled={disabled} required={required} />}
                />
              );
            })}
          </RadioGroup>
        )}
      />
      {errors && <FormHelperText error>{errors[name]?.message}</FormHelperText>}
    </FormControl>
  );
};
export default WsRadioGroup;
